import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { FailState } from "../../models/fail-state";
import { ProposalsByProductState } from "../../models/proposal-by-product.state";
import { AppState } from "../../reducers";
import { ProposalSelectors } from "../../selectors/proposal.selectors";

@Injectable()
export class ProposalsByProductGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.proposalsByProduct.get),
			withLatestFrom(this.store.select(ProposalSelectors.proposalsByProduct)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(OrderProposalActions.proposalsByProduct.getSuccess(state))
					: of(OrderProposalActions.proposalsByProduct.getApi({ status: action.status }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(OrderProposalActions.proposalsByProduct.getApi),
			switchMap((action) =>
				this.orderProposalService.byProduct(action.status).pipe(
					map((proposals) =>
						OrderProposalActions.proposalsByProduct.getSuccess({
							proposals,
							loading: false
						})
					),
					catchError((error) =>
						of(OrderProposalActions.proposalsByProduct.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: ProposalsByProductState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
